angular.module('impactx.statistic').controller('ReportStatUserListCtrl', ReportStatUserListCtrl);

function ReportStatUserListCtrl() {
    var self = this;

    self.buttonDefinition = [];

    self.meta = {
        rowTemplate: 'modules/statistic/templates/reportstatuserlist.row.tmpl.html',
        isSelectAble: false,
        ctrl: this,
        endpoint: '/statistic/reportstatuserlist',
        id: "reportstatuserlist",
        buttonDefinition: self.buttonDefinition,
        noAutoRefresh: true
    };

    self.getMeta = function () {
        return self.meta;
    };
}